import { render } from "./ComplaintTab.vue?vue&type=template&id=356a78a7&scoped=true"
import script from "./ComplaintTab.vue?vue&type=script&lang=js"
export * from "./ComplaintTab.vue?vue&type=script&lang=js"

import "./ComplaintTab.vue?vue&type=style&index=0&id=356a78a7&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356a78a7"]])

export default __exports__